<template>
  <div id="main-content" class="add-bus">
    <el-col :offset="1" :span="22" :xl="22" :lg="23"  >
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form class="edit-category" autocomplete="off">
        <el-row >
          <el-col :span="4">
            <span class="required-star">* </span><span class="form-lable">{{ $t('categoryM.form.name') }}</span>
          </el-col>
          <el-col :span="17">
            <div class="pr-4">
              <input class="input w-100" v-model="category.name"  type=""/>
            </div>
            <span v-if="errorInfo.name" class="form-error"> {{ errorInfo.name }}</span>
          </el-col>
        </el-row>
        <el-row class="mt-3">
          <el-col :span="24">
              <div class="flex-start">
                <span class="required-star">* </span><span class="form-lable">{{ $t('categoryM.form.listFile') }}</span>
                <el-button @click="addNewFile"  type="success"
                           icon="el-icon-plus"
                           circle></el-button>
                <span class="text-add-file">{{ $t('common.add_new_file') }}</span>
              </div>
          </el-col>
          <el-col :span="24">
            <div class="text-left ml-3">
              <draggable v-model="category.files" tag="div">
              <el-row class="pt-4" v-for="(file,index) in category.files" :key="index">
                <el-col :span="8">
                  <span class="required-star">* </span><span class="form-lable">{{ $t('categoryM.form.titleFile') }}</span>
                  <input autocomplete="off" v-model="file.title" :class="$i18n.locale ==='ja' ?  'input input-title' : 'input'" />
                  <div  class="form-error"  v-if="errorInfo.files[index] && errorInfo.files[index].title">{{errorInfo.files[index].title}}</div>
                </el-col>
                <el-col :span="8">
                  <span class="required-star">* </span><span class="form-lable">{{ $t('fileM.password') }}</span>
                  <el-switch class="mr-1" v-model="file.status" :active-value="1" :inactive-value="0"></el-switch>
                  <el-input  autocomplete="off" :id="`input-password_${file.id}`" v-model="file.password" style="width: 48%" show-password />
                  <div  :class="{'form-error form-error-passw': true , 'form-error-vn':$i18n.locale==='vn'}"   v-if="errorInfo.files[index] && errorInfo.files[index].password">{{errorInfo.files[index].password}}</div>
                </el-col>
                <el-col :span="7">
                  <div class="d-flex">
                    <span class="required-star">* </span><span class="form-lable text-file">{{ $t('categoryM.form.file') }}</span>
                    <b-form-file
                        id="parentFile" @change="onUploadFile($event, index)"
                         v-model="listFiles[index]"
                        accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf, .csv"
                        style="width: 100%; float: left"
                        :placeholder="$t('common.choose_file')"
                        :drop-placeholder="$t('common.drop_file')"
                    ></b-form-file>
                  </div>
                  <div class="form-error error-two" v-if="errorInfo.files[index] &&errorInfo.files[index].file_url">{{errorInfo.files[index].file_url}}</div>
                </el-col>
                <el-col :span="1" class="d-flex">
                  <el-button   type="success" class="mx-2" :disabled="!category.files[index].file_url" @click="onShowPreviewPDF(index)"
                               icon="el-icon-view" size="small"
                               circle></el-button>
                  <i class="el-icon-rank icon-move"></i>
                  <i @click="onDeleteItem(index)" class="el-icon-close icon-move ml-3 text-danger"></i>
                </el-col>
              </el-row>
              </draggable>
              <div class="form-error" v-if="errorInfo.listFile">{{errorInfo.listFile}}</div>
            </div>
          </el-col>
        </el-row>
        <el-row class="mt-4">
          <el-col :span="4">
            <span class="form-lable">{{ $t('categoryM.note') }}</span>
          </el-col>
          <el-col :span="17" >
            <div class="pr-4">
              <b-form-textarea
                  style="float: left !important;"
                  id="textarea" class="w-100"
                  v-model="category.note"
                  placeholder=""
                  rows="4"
                  max-rows="6"
              ></b-form-textarea>
            </div>
            <div v-if="errorInfo.note"  class="form-error"> {{ errorInfo.note }}</div>
          </el-col>
        </el-row>
        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>
<script>
import PageTitle from "@/components/PageTitle";
import draggable from 'vuedraggable'
export default {
  components:{
    PageTitle,
    draggable
  },
  data(){
    return{
      title:'categoryM.titleAdd',
      backLink: '/category-management',
      isUploadFile: 0,
      listFiles: [],
      isEdit: false,
      category:{
        name:'',
        files: [],
        note: ''
      },
      new_file:{
        title: null,
        password:null,
        file_url: null,
        status:null
      },
      files: [],
      arrayTest1:[
        {value:null},
        {value:null},
      ],
      errorInfo: {
        name: null,
        files: [],
        password:null,
        note: null,
        listFile: null,
      },
      defaultPassword: null,
    }
  },
  watch:{
  },
  created() {
    this.onGetDefaultPassword()
    if(this.$route.query.id){
      let idCategory = this.$route.query.id
      this.getDataById(idCategory)
    }
  },
  methods:{
    onGetDefaultPassword(){
      let successCallback = (res) =>{
        if(res.status ===200){
          this.defaultPassword = res.data.data.password_default
        }
      }
      let errorCallback = () => {}

      let payload ={
        errorCallback,
        successCallback
      }
      this.$store.dispatch('CategoriesFile/getPasswordDefault', payload)
    },
    getDataById(id){
      let successCallback = async (response) => {
        if(response.status ===200){
          const {file_category } = response.data.data
          this.category = file_category
          this.listFiles = file_category.files.map(el=> { return el.file_url})
          this.isEdit = true
          this.title = 'categoryM.titleEdit'
        }
      }
      let errorCallback = () => {}
      let payload = {
        category_id: id,
        successCallback,
        errorCallback
      }
      this.$store.dispatch('CategoriesFile/getDetailCategory', payload)
    },
    onDeleteItem(indexItem){
      this.listFiles.splice(indexItem, 1)
      this.category.files.splice(indexItem, 1)
    },
    addNewFile(){
      const data ={title: '', password: this.defaultPassword || '',
        file_url: null, status:0}
        this.listFiles.push()
      this.category.files.push(data)
    },
    async  submitAction(){
      let successCallback = async (response) => {
        if(response.status ===200){
          this.$router.push('/category-management')
          this.$notify({
            title: this.$t('msg.titleSuccess'),
            message: this.isEdit ? this.$t('msg.contentUpdateSuccess', { field: this.$t('nameField.category') }) : this.$t('msg.contentCreateSuccess', { field: this.$t('nameField.category') }),
            type: 'success'
          })
        }
      }
      let errorCallback = () => {}
      let category = Object.assign({}, this.category)
      let arrFiles = []
      category.files.map((el,index)=>{
        let obj = {
          order:index+1,
          id:el.id || null,
          title:el.title,
          password:el.password || this.defaultPassword,
          file_url : el.file_url,
          status:el.status
        }
        arrFiles.push(obj)
      })
      let data  ={
        name: category.name,
        note: category.note,
        files: [].concat(arrFiles),
        id: category.id || null
      }
      let payload = {
        data: data,
        successCallback,
        errorCallback
      }
      if(this.onValidate()){
        if(this.isEdit){
          this.$store.dispatch('CategoriesFile/updateCategory', payload)
        }else{
          this.$store.dispatch('CategoriesFile/createCategory', payload)
        }
      }else{
        this.$store.commit('openNotification', {
          type: 'error',
          message: this.$t('common.please_check_input_error')
        })
      }

    },
     onUploadFile(event, index){
      let  file = event.target.files[0]
      let successCallback = async (response) => {
        if(response.status ===200){
          let url = await response.data.data.file_url
          if(url){
            this.category.files[index].file_url = url
          }
        }
      }
      let errorCallback = () => {}
      let formData = new FormData()
      formData.append('file', file)
      let payload = {
        data: formData,
        successCallback,
        errorCallback
      }
      let size = file.size / 1024 / 1024 > 25
      if (size) {
        this.$notify({
          title: this.$t('msg.titleError'),
          message: this.$t('msg.imageSize'),
          type: 'error'
        })
        return false
      }else{
        this.$store.dispatch('CategoriesFile/uploadFile', payload)
      }
    },
    onResetErr(){
      let errors = {
        name: null,
        files: [],
        note: null,
        listFile: null,
      }
      this.errorInfo = errors
    },
    onShowPreviewPDF(ind){
      if(ind>-1){
        let file_url = this.category.files[ind].file_url || null
        if(file_url){
          window.open(file_url, '_blank')
        }
      }
    },
    onValidate(){
      this.onResetErr()
      let check = true
      let category = Object.assign({}, this.category)
      if(category.name ==='' || category.name ===null || (category.name && category.name.trim().length ===0)){
        check = false
        this.errorInfo.name = this.$t('msg.required', {field: this.$t('categoryM.form.name')})
      }else{
        this.errorInfo.name =  ''
      }
      if(category.name && category.name.length >255){
        check= false
        this.errorInfo.name = this.$t('common.errorMaxLength', {field: 255})
      }
      if(category.files.length ===0){
        this.errorInfo.listFile = this.$t('msg.requiredAddFile')
        check = false
      }else{
        this.errorInfo.listFile = ''
        category.files.forEach((el,index)=>{
          this.errorInfo.files.push({title: '', file_url: ''})
          if(el.title ==='' || el.title === null){
            check = false
            this.errorInfo.files[index].title = this.$t('msg.required', {field: this.$t('categoryM.form.titleFile')})
          }
          if(el.password ==='' || el.password === null || (el.password && el.password.trim()==='')){
            check = false
            this.errorInfo.files[index].password = this.$t('msg.required', {field: this.$t('fileM.password')})
          }
          if(el.title && el.title.length >255){
            check = false
            this.errorInfo.files[index].title = this.$t('common.errorMaxLength' ,  {field: 255})
          }
          if (el.file_url ===''|| el.file_url === null){
            this.errorInfo.files[index].file_url = this.$t('msg.requiredAddFile', {field: this.$t('categoryM.form.file')})
            check = false
          }
        })
      }
      return check
    }
  }
}
</script>
<style lang="scss">
.edit-category{
  padding: 1rem 5rem;
}
.text-add-file{
  line-height: 40px;
  margin-left: 20px;
  font-size: 22px
}
.icon-move{
  font-weight: bold;
  font-size: 30px;
  margin: .1rem 0 0 .8rem;
}
.flex-end{
  display: flex;
  justify-content: flex-end;
  justify-items: center;
}
.text-file{
  min-width: 100px;
}
.flex-start{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
